import { useState } from 'react';

import { ArrowRightIcon, Button, ButtonSize, ButtonVariant, Upload } from '@/components';
import { useRouter } from '@/hooks';
interface Props {
  onValidate: (file: File | undefined) => void;
}
export default function UploadPdf(props: Props) {
  const { onValidate } = props;
  const [file, setFile] = useState<File>();
  const router = useRouter();
  return (
    <div className="flex flex-row">
      <div className="w-[39vw] bg-tangerine-500 min-h-screen">
        <div className="ml-16 mt-10 ">
          <img
            className="cursor-pointer"
            onClick={() => {
              router.push('/dashboard');
            }}
            src="https://sign-public-cdn.s3.us-east-1.amazonaws.com/signature-next/logo-white_230823022528_240723062316.webp"
            width={93.5}
            height={40}
          ></img>
        </div>
        <div className="font-semiBold text-[31px]/[42px] text-white ml-16 mt-[73px] font-semibold">
          Digital Signature<br></br>Verification & Contract Audit
        </div>
        <div className="text-md text-white ml-16 mt-4 font-normal">Validate and audit your signed contracts</div>
        <div className="mt-[128px]">
          <img
            src="https://sign-public-cdn.s3.us-east-1.amazonaws.com/signature-next/left-bg_240723072348.webp"
            width={384}
            height={418}
          ></img>
        </div>
      </div>
      <div className="relative pl-28 pr-32  bg-gray-25 flex-1 flex justify-center items-center flex-col min-h-screen">
        <div className="w-full font-semiBold text-[31px]/[42px] text-gray-900 font-semibold">
          Upload a Signed Contract
        </div>
        <div className="w-full font-medium  text-gray-500  mt-4 text-sm">
          Upload a contract signed on EthSign to validate its contents and digital signatures using cryptography and
          on-chain data.
        </div>
        <div className="mt-16 w-full">
          <Upload
            getFile={(file) => {
              setFile(file);
            }}
            maxSize={1000}
            description="Supports PDF file"
          ></Upload>
        </div>
        <div className="absolute right-32 bottom-[5vh]">
          <Button
            disabled={!file}
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.LARGE}
            iconRight={
              <span className="ml-2">
                <ArrowRightIcon width={16} height={16} />
              </span>
            }
            onClick={() => {
              onValidate(file);
            }}
          >
            Validate Now
          </Button>
        </div>
      </div>
    </div>
  );
}
